import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarService } from './snackbar.service';

export function provideSnackbar(): EnvironmentProviders {
  return makeEnvironmentProviders([importProvidersFrom(MatSnackBarModule), SnackbarService]);
}
